import Repository from './Repository';

const resource = '/file';

export default class FileRepository {
  static uploadFile(token, file, isNde) {
    const formData = new FormData();

    /*
        Add the form data we need to submit
    */
    formData.append('token', token);
    formData.append('delivery_file', file);
    formData.append('isNde', isNde ? 1 : 0);


    return Repository.post(`${resource}/upload`, formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
  }
}
